import faqData from '../content/faq.json';

type FAQItem = { q: string; a: string };

export default function FAQ() {
  const list = ((faqData as any).items as FAQItem[]) || [];
  return (
    <main id="main">
      <section className="section">
        <div className="container" style={{ maxWidth: 900 }}>
          <h1 className="section-title">FAQ</h1>
          <div style={{ display: 'grid', gap: 12 }}>
            {list.map((item, i) => (
              <details
                key={i}
                style={{
                  background: '#0f0f0f',
                  border: '1px solid #232323',
                  borderRadius: 12,
                  padding: '12px 14px',
                }}
              >
                <summary style={{ cursor: 'pointer', fontWeight: 700 }}>{item.q}</summary>
                <p style={{ margin: '8px 0 0', color: 'var(--light)' }}>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

